export default [
  {
    id: 'design-profile',
    title: 'プロフィール',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'address',
    title: '住所',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'contacts',
    title: '連絡先',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'id-photo',
    title: '証明写真',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'job-category',
    title: '職種',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'edu-history',
    title: '学歴',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'skills',
    title: 'スキル',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'license-history',
    title: '免許・資格',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'job-history',
    title: '職歴',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'mypr',
    title: '自己PR',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'hobby',
    title: '趣味',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'main-image',
    title: 'メイン画像',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'create-date',
    title: '作成日',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'confirm',
    title: '確認',
    previewJumpId: 'confirm-preview'
  },
  {
    id: 'output',
    title: '完了',
    previewJumpId: 'close-preview-button-above'
  }
]
